import { useState } from 'react'
import { supabase } from '@/lib/supabase'
import { authFetch } from '@/lib/auth-fetch'

export async function inviteTeamMember(
  email: string, 
  role: string, 
  eventId?: string,
  newEventData?: {
    title: string
    event_date: string
    number_of_guests: number
    description?: string
  }
) {
  const body: any = { email, role }
  
  if (role === 'klient') {
    if (eventId) {
      body.event_id = eventId
    } else if (newEventData) {
      body.new_event_data = newEventData
    }
  }

  const response = await authFetch('/api/team/invite', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to send invitation')
  }

  const data = await response.json()
  return { 
    success: true, 
    token: data.token,
    demoMode: data.demoMode || false,
    message: data.message,
  }
}

export async function assignTeamMemberToEvent(eventId: string, userId: string) {
  const { error } = await supabase
    .from('team_members')
    .insert([{ event_id: eventId, user_id: userId }])

  if (error) throw error
  return { success: true }
}

